// Who can reach the Weight v2 screens.
//
// In a production build, only a merchant in the Weight v2 programme: one whose weightEngineMode
// (MerchantConfig, returned by GET config/merchant/{id} at login) is SHADOW or LIVE. Ops put a
// merchant in SHADOW with POST /api/v2/wd/admin/engine/mode, which changes no bill, and the screens
// appear for that merchant from their next login (a Prozo login: the next time it picks the merchant).
//
// Every Weight v2 route carries `enableForConfig: WEIGHT_V2_CONFIG`. For everyone else that removes
// the sidebar row, the menu-search entry AND the route itself, so a pasted URL does not open either.
//
// Each environment is a separate build and CRA inlines REACT_APP_ENV at build time:
//
//   npm start               REACT_APP_ENV = local       -> every merchant
//   npm run build:staging   (not set) -> undefined      -> every merchant   (QA needs no mode set)
//   npm run build:prod      REACT_APP_ENV = prod        -> SHADOW / LIVE merchants only
//
// It gates only the NEW v2 screens. `/weight-discrepancy`, the existing dispute list, stays for
// every merchant.
//
// Depends on .env.prod setting REACT_APP_ENV=prod. Remove that line and every merchant gets the screens.
export const WEIGHT_V2_CONFIG_KEY = 'weightV2Enabled'
export const WEIGHT_V2_CONFIG = process.env.REACT_APP_ENV === 'prod' ? WEIGHT_V2_CONFIG_KEY : undefined

/** Every Weight v2 destination. Each must carry the gate above in routes.config. */
export const WEIGHT_V2_PATHS = new Set([
  '/weight-disputes-v2',
  '/weight-freeze-v2',
  '/weight-freeze-v2/initiate',
  '/weight-freeze-v2/dws',
  '/weight-freeze-v2/product-master',
])

/** True for a merchant in the programme: the backend's weight engine mode is SHADOW or LIVE. */
export function isWeightV2Merchant(weightEngineMode) {
  const mode = String(weightEngineMode || '').trim().toUpperCase()
  return mode === 'SHADOW' || mode === 'LIVE'
}
